// DiseasePage.tsx
import React from "react";
import { Container, Box, Typography, Grid, Divider } from "@mui/material";
import { lightBlue } from "@mui/material/colors";
import { CaseCardType } from "../../Modules/ViewCase/CaseCard";
import CaseCard from "../../Modules/ViewCase/CaseCard";

type Disease = {
  id: string;
  name: string;
  tag: string;
  definition: string;
  common_age: string;
  symptom: string;
  case_list: string[];
};

type DiseasePageProps = {
  disease: Disease | null;
  cases: CaseCardType[];
};

const DiseaseData: React.FC<DiseasePageProps> = ({ disease, cases }) => {
  if (!disease) {
    return null; // 病気が選択されていない場合は表示しない
  }

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Typography
        variant="h4"
        component="div"
        sx={{
          textAlign: "left",
          fontWeight: "bold",
        }}
      >
        {disease.name}
      </Typography>

      <Divider sx={{ bgcolor: "black", mt: 0.5, mb: 1 }} />

      <Container
        sx={{
          backgroundColor: lightBlue[50],
          mt: 4,
          mb: 4,
          borderRadius: 2,
        }}
      >
        <Grid container sx={{pt: 2, pb: 1}}>
          <Typography variant="h6" sx={{ textAlign: "left"}}>
            典型例
          </Typography>
        </Grid>

        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gridTemplateColumns: { sm: "50% 50%", xs: "100%" },
            pb:4
          }}
        >
          {cases && cases.length > 0 ? (
            cases.map((CaseData: CaseCardType) => (
              <Grid item key={CaseData.id} xs={12} sm={6}>
                <CaseCard
                  id={CaseData.id}
                  title={CaseData.title}
                  age={CaseData.age}
                  sex={CaseData.sex}
                  patientId={CaseData.patientId}
                  site={CaseData.site}
                  modality={CaseData.modality}
                  date={CaseData.date}
                  organTags={CaseData.organTags}
                  keyImages={CaseData.keyImages}
                  casenumber={CaseData.casenumber}
                />
              </Grid>
            ))
          ) : (
            <Grid item xs={12} sx={{ mb: 3 }}>
              <Typography variant="h6" align="center">
                画像は準備中です
              </Typography>
            </Grid>
          )}
        </Grid>
      </Container>
    </Container>
  );
};

export default DiseaseData;
